const r = (t) => t < 10 ? `0${t}` : `${t}`, s = (t) => {
  if (typeof t == "object") return t;
  const e = typeof t == "string" && !t.includes("-") ? parseInt(t, 10) : t;
  return new Date(e);
}, c = (t) => {
  const e = s(t);
  let o = e.getDate();
  if (!o) return "";
  o = r(o);
  const n = r(e.getMonth() + 1), a = e.getFullYear();
  return `${o}/${n}/${a}`;
}, d = (t) => {
  const e = s(t), o = e.getDate();
  if (!o) return "";
  const n = e.toLocaleString("default", { month: "short" });
  return `${o} ${n} ${e.getFullYear()}`;
};
export {
  c as formatDate,
  d as formatShortDate,
  s as getDateObj,
  r as pad
};
